export const gnrStateEnum = {
    REQUESTED: 1,
    IN_PROGRESS: 2,
    DELIVERED: 3,
    CANCELED: 4,
    ARCHIVED: 5,
};

export const gnrPeriodEnum = {
    VERY_EARLY_MORNING: 1,
    MORNING: 2,
    AFTERNOON: 3,
    FULL_DAY: 4,
};
